"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("@powerednow/complexData/entity");
let UsageHistoryEntity = class UsageHistoryEntity extends entity_1.EntityWithCompanyId {
};
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true, unique: 'compositeIndex' })
], UsageHistoryEntity.prototype, "company_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', primaryKey: true, unique: 'compositeIndex' })
], UsageHistoryEntity.prototype, "year_month", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "active_purchases", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "expired_purchases", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], UsageHistoryEntity.prototype, "track_location", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], UsageHistoryEntity.prototype, "auto_close_projects", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], UsageHistoryEntity.prototype, "auto_archive_by_project", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], UsageHistoryEntity.prototype, "auto_archive_by_item", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], UsageHistoryEntity.prototype, "company_name", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], UsageHistoryEntity.prototype, "phone", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], UsageHistoryEntity.prototype, "is_vat_registered", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], UsageHistoryEntity.prototype, "is_cis_enabled", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], UsageHistoryEntity.prototype, "is_disbursements_enabled", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], UsageHistoryEntity.prototype, "mtd_enabled", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "team_size", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], UsageHistoryEntity.prototype, "business_type", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], UsageHistoryEntity.prototype, "currency", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], UsageHistoryEntity.prototype, "postcode", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "sites_count", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "invoicing_addresses_count", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "users", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], UsageHistoryEntity.prototype, "email", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "customers", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "customers_linked_to_pn", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "form_documents_count", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "signatures", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "jobs", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "media", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "time_logs", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "emails_sent", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "emails_opened", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "sms_messages_sent", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "checkins", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "notes", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], UsageHistoryEntity.prototype, "sumup_enabled", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], UsageHistoryEntity.prototype, "sumup_online_enabled", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], UsageHistoryEntity.prototype, "xero_interface_enabled", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], UsageHistoryEntity.prototype, "xero_usage_enabled", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], UsageHistoryEntity.prototype, "active_subscription_tiers", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "appointments", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "reminders", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "priced_items", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "documents", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "sales_invoices", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float' })
], UsageHistoryEntity.prototype, "sales_invoices_amount", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "sales_credit_notes", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "quotes", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "job_sheets", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "supplier_invoices_and_expenses", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float' })
], UsageHistoryEntity.prototype, "supplier_invoices_and_expenses_total", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "expenses", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float' })
], UsageHistoryEntity.prototype, "expenses_total", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "payments", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float' })
], UsageHistoryEntity.prototype, "payments_amount", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float' })
], UsageHistoryEntity.prototype, "expense_payments_amount", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "sumup_payments_count", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float' })
], UsageHistoryEntity.prototype, "sumup_payments_amount", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "sumup_online_payments_count", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float' })
], UsageHistoryEntity.prototype, "sumup_online_payments_amount", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "cash_payments_count", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float' })
], UsageHistoryEntity.prototype, "cash_payments_amount", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "cheque_payments_count", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float' })
], UsageHistoryEntity.prototype, "cheque_payments_amount", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "bank_transfer_payments_count", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float' })
], UsageHistoryEntity.prototype, "bank_transfer_payments_amount", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "paypal_standard_payments_count", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float' })
], UsageHistoryEntity.prototype, "paypal_standard_payments_amount", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "paypal_here_payments_count", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float' })
], UsageHistoryEntity.prototype, "paypal_here_payments_amount", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "paypal_checkin_payments_count", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float' })
], UsageHistoryEntity.prototype, "paypal_checkin_payments_amount", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "direct_debit_payments_count", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float' })
], UsageHistoryEntity.prototype, "direct_debit_payments_amount", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "standing_order_payments_count", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float' })
], UsageHistoryEntity.prototype, "standing_order_payments_amount", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "chip_and_pin_payments_count", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float' })
], UsageHistoryEntity.prototype, "chip_and_pin_payments_amount", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], UsageHistoryEntity.prototype, "credit_card_manual_payments_count", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float' })
], UsageHistoryEntity.prototype, "credit_card_manual_payments_amount", void 0);
UsageHistoryEntity = __decorate([
    entity_1.EntityDecorator
], UsageHistoryEntity);
exports.default = UsageHistoryEntity;
//# sourceMappingURL=../../../../src/models/usageHistory/entity.js.map